import React from "react";
import { isNumber, map, size, slice, sortBy } from "lodash";
import { Locale } from "@linkfluence/models/locale";
import intersperse from "@ui-kit/utils/intersperse";
import { tr } from "@radarly/i18n";
import { ClauseLabels } from "@radarly/models/clause/label";
import Label from "./label";

const RadarlyComponentsClauseLabelsRecap = React.memo(
  ({
    clauseLabels,
    locale,
    max = 1,
    colorized,
    field,
  }: {
    clauseLabels: ClauseLabels;
    locale: Locale;
    max?: number;
    colorized?: boolean;
    field?: string;
  }) => {
    const slicedLabels = isNumber(max)
      ? slice(clauseLabels.labels, 0, max)
      : clauseLabels.labels;

    const diff = size(clauseLabels.labels) - size(slicedLabels);
    return (
      <>
        {field && (
          <span>
            {tr(locale, "PREFIX", { label: field })}
          </span>
        )}
        {intersperse(
          map(sortBy(slicedLabels, "excluded"), (label) => (
            <Label colorized={colorized} label={label} locale={locale} />
          )),
          (i) => (
            <span>,&nbsp;</span>
          )
        )}
        {diff > 0 && <span>&nbsp;(+{diff})</span>}
      </>
    );
  }
);

export default RadarlyComponentsClauseLabelsRecap;
